import { ImageSearchStateType, SearchImageSetPayload } from "@type/index";
import { fileToBase64 } from "@util/common";
import { ActionsUnion, createAction } from "../helpers";
// set img page search param
export const SET_SEARCH_IMAGE = "[image search] SET PARAM";
export const CLEAR_SEARCH_IMAGE = "[image search] CLEAR PARAM";

export const Actions = {
  setSearchImage: (payload: SearchImageSetPayload) =>
    createAction(SET_SEARCH_IMAGE, payload),
  clearSearchImage: () => createAction(CLEAR_SEARCH_IMAGE)
};

type ActionType = ActionsUnion<typeof Actions>;

const initialState: ImageSearchStateType = {
  image: null
};

export default (
  state: ImageSearchStateType = initialState,
  action: ActionType
): ImageSearchStateType => {
  switch (action.type) {
    case SET_SEARCH_IMAGE: {
      fileToBase64(action.payload.image).then((baseFile) => {
        window.localStorage.setItem("searchImage", baseFile);
      });
      return { ...state, image: action.payload.image };
    }
    case CLEAR_SEARCH_IMAGE: {
      return { ...state, image: null };
    }
    default:
      return state;
  }
};
